import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-edit\"><g fill-rule=\"nonzero\" fill=\"none\"><path d=\"M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Z\" fill=\"#2E5BFD\" /><path d=\"m8.09 5.702 2.208 2.208-3.372 3.372a.335.335 0 0 1-.17.092l-2.308.46c-.154.031-.282-.066-.288-.217a.281.281 0 0 1 .005-.066l.46-2.308a.335.335 0 0 1 .093-.169L8.09 5.702ZM9.53 4.26c.12-.12.297-.136.397-.036l1.848 1.848c.099.1.083.277-.036.397l-.889.887-2.208-2.208Z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol